(function(){
    'use strict';
    jQuery(document).ready(function($){
        // Prevent click on `ul` from triggering the `li` toggle
        $('.site-nav__childlist-item ul').on('click', function (e) {
            e.stopPropagation(); // Stop the event from propagating to the parent `li`
        });

        // Handle click on `li` with the class `site-nav__childlist-item`
        $('.site-nav__childlist-item').on('click', function (e) {
            const $this = $(this);

            // Check if the `li` has a `<ul>` inside
            if ($this.find('ul').length > 0) {
                e.preventDefault(); // Prevent the default link action if `<ul>` is present
                e.stopPropagation(); // Prevent the event from bubbling up

                if (!$this.hasClass('active')) {
                    // If not already active, close all others and open this one
                    $('.site-nav__childlist-item.active').removeClass('active').find('ul').slideUp();
                    $this.addClass('active').find('ul').slideDown();
                } else {
                    // If already active, close it
                    $this.removeClass('active').find('ul').slideUp();
                }
            }
        });

// Optional: Close all dropdowns if clicking anywhere else on the page
$(document).on('click', function () {
    $('.site-nav__childlist-item.active').removeClass('active').find('ul').slideUp();
});
        $('button.mobile-nav__link.mobile-nav__sublist-link').click(function() {
            $(this).toggleClass('active').next('.mobile-nav__dropdown').slideToggle();
            $(this).parent('li').siblings('li').find('.mobile-nav__dropdown').slideUp();
            $(this).parent('li').siblings('li').find('button.mobile-nav__sublist-link').removeClass('active');
        })

        $('.image-text .read-more-button').click(function() {
            var text = $(this).text();
            text = text.replace('Read More', 'Read Less');
            $(this).text(text); 
            $(this).toggleClass('active');
            $('.index-section.image-text .featured-row__subtext .more-text').slideToggle();
        });

        $('button.site-header__menu.js-mobile-nav-toggle').click(function() {
            $('.mobile-nav-wrapper-shop').removeClass('js-menu--is-open js-menu--header-shop');
            $('.site-header__icons button.site-header__shop').removeClass('site-header__shop-open');
            if($(this).hasClass('site-header__menu-open')) {
                $(this).removeClass('site-header__menu-open');
                $('html').removeClass('menu-open');
            }else {
                $(this).addClass('site-header__menu-open');
                $('html').addClass('menu-open');
            }
        });

        $('.site-header__icons button.site-header__shop').click(function() {
            $('.mobile-nav-wrapper').removeClass('js-menu--is-open');
            $('.site-header__icon.site-header__menu.js-mobile-nav-toggle').removeClass('mobile-nav--close site-header__menu-open').addClass('mobile-nav--open');
            if($(this).hasClass('site-header__shop-open')) {
                $(this).removeClass('site-header__shop-open');
                $('html').removeClass('menu-open');
                $('nav.mobile-nav-wrapper-shop').removeClass('js-menu--is-open js-menu--header-shop');
            }else {
                $(this).addClass('site-header__shop-open');
                $('html').addClass('menu-open');
                $('nav.mobile-nav-wrapper-shop').addClass('js-menu--is-open js-menu--header-shop');
            }
        });

        $('.home-blog .grid--blog').owlCarousel({
            loop:true,
            margin:0,
            nav:false,
            dots:false,
            items:1,
            responsive : {
                0 : {
                    items:1
                },
                568 : {
                    items:2
                },
                1024 : {
                    items:3
                }
            }
        });

        $('.instagram-custom .imstagram-list').owlCarousel({
            loop:false,
            margin:0,
            nav:false,
            dots:false,
            items:1,
            responsive : {
                0 : {
                    items:1,
                    loop:true
                },
                568 : {
                    items:2
                },
                1024 : {
                    items:3
                }
            }
        });

        windowHeight();
    });
    $(window).on('resize', function(){
        windowHeight();
    });

    const windowHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--headerHeight', $('#shopify-section-header').outerHeight()+`px`);
        doc.style.setProperty('--headerHeightInner', $('.site-header').outerHeight()+`px`);
    }
    const appHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight();
})();